import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Range } from '../core/range.js';
/**
 * Contains all data needed to render at a specific viewport.
 */

export var ViewportData = /*#__PURE__*/function () {
  function ViewportData(selections, partialData, whitespaceViewportData, model) {
    _classCallCheck(this, ViewportData);

    this.selections = selections;
    this.startLineNumber = partialData.startLineNumber | 0;
    this.endLineNumber = partialData.endLineNumber | 0;
    this.relativeVerticalOffset = partialData.relativeVerticalOffset;
    this.bigNumbersDelta = partialData.bigNumbersDelta | 0;
    this.whitespaceViewportData = whitespaceViewportData;
    this._model = model;
    this.visibleRange = new Range(partialData.startLineNumber, this._model.getLineMinColumn(partialData.startLineNumber), partialData.endLineNumber, this._model.getLineMaxColumn(partialData.endLineNumber));
  }

  _createClass(ViewportData, [{
    key: "getViewLineRenderingData",
    value: function getViewLineRenderingData(lineNumber) {
      return this._model.getViewLineRenderingData(this.visibleRange, lineNumber);
    }
  }, {
    key: "getDecorationsInViewport",
    value: function getDecorationsInViewport() {
      return this._model.getDecorationsInViewport(this.visibleRange);
    }
  }]);

  return ViewportData;
}();